module.exports = __webpack_public_path__ + "img/SMT_37_Mr_Gerald_Ng.f5f70660.jpg";